export default __webpack_public_path__ + "static/media/collar.f684a2ed.svg";